<template>
    <div>
        <span>哈哈哈</span>
    </div>  
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
     props: {
        
    },
    data(){
        return{
            
        }
    },
    methods:{
        
    }
}
</script>
<style lang="less" scoped>

</style>






// WEBPACK FOOTER //
// src/page/main_content/alarm/listCarousel.vue